import React from 'react';
import useTranslations from '../../../hooks/useTranslations';
import OTButton from '../../Button';
import { Options } from '../engine/SingleChoiceFieldEngine';
import styled from 'styled-components/macro';
import { Tooltip } from '@material-ui/core';

const Button = styled(OTButton)`
  && {
    font-size: 12px;

    line-height: 1.5rem;
    margin: 0 1rem 1rem 0;
  }
`;

const ButtonsWrapper = styled.div`
  padding-top: 9px;
  display: flex;
  flex-wrap: wrap;
`;

const SingleChoiceFieldView = props => {
  return (
    <ButtonsWrapper data-testid={`yes-no-wrapper-${props.internalId}`}>
      {props.options.map(b => (
        <Tooltip title={b ? props.tooltips[b] || '' : ''} arrow>
          <Button
            key={b}
            data-testid={`buttons-${b}-${props.internalId}`}
            onClick={() => props.onBtnClick(b)}
            variant={props.value === b ? 'contained' : 'outlined'}
            size="small"
            disabled={props.readOnly}
            customCSS="letter-spacing: 0px !important;"
          >
            {b}
          </Button>
        </Tooltip>
      ))}
    </ButtonsWrapper>
  );
};

export default SingleChoiceFieldView;
